export default "__VITE_ASSET__uNQHQsgw__"